/* Recharge Cart ATC harmonizer (v4) -Jenny 10/23/25
   - PDP + Featured Product: flip submit->button so Recharge doesn't early-return
   - Quick View: KEEP submit, and force-submit the enclosing form when region is clicked
   - Works with dynamically injected basicLightbox content
*/

(function () {
  if (window.__BB_RC_ATC_V33__) return;
  window.__BB_RC_ATC_V33__ = true;

  // Real “Add to Cart” buttons Recharge/Theme care about
  const BUTTON_SELECTOR =
    'button[name="add"][data-product-submit], button.product__add-to-cart[name="add"]';

  // Visual wrappers we allow “click anywhere” on
  const REGION_SELECTOR = [
    '.buttons-holder',
    '.buttons-holder-fix',
    '.product__buy-buttons',
    '.product--add-to-cart',
    '.product--add-to-cart-button',
    'product-form.product--add-to-cart-form',
    'form[action*="/cart/add"]',
    '.quick-view__footer',
    '.quick-view',
    // anything living inside the basicLightbox (Quick View modal)
    '.basicLightbox'
  ].join(',');

  function isRechargePresent() {
    return !!(
      window.Recharge ||
      window.RechargeCart ||
      document.querySelector(
        '[data-recharge-cart], #recharge-cart-drawer, recharge-cart, recharge-cart-drawer'
      )
    );
  }

  function toArray(nl) {
    return Array.prototype.slice.call(nl || []);
  }

  function isQuickViewButton(btn) {
    // Quick View lives inside <product-quick-view> rendered into a .basicLightbox container
    return !!(btn && (btn.closest('product-quick-view') || btn.closest('.basicLightbox')));
  }

  function normalizeButton(btn) {
    if (!btn) return;

    const inQuickView = isQuickViewButton(btn);

    // On PDP/featured we convert submit->button to avoid Recharge’s early-return on form submit
    if (!inQuickView && btn.getAttribute('type') === 'submit') {
      btn.setAttribute('data-bb-original-type', 'submit');
      btn.setAttribute('type', 'button');
    }

    btn.setAttribute('role', 'button');
  }

  function restoreButton(btn) {
    if (!btn) return;
    if (btn.getAttribute('data-bb-original-type') === 'submit') {
      btn.setAttribute('type', 'submit');
      btn.removeAttribute('data-bb-original-type');
    }
  }

  function isInteractiveTarget(t) {
    return !!(
      t &&
      (t.closest('a, [role="link"]') ||
        t.closest('input, select, textarea, button') ||
        t.closest('product-quantity, .quantity'))
    );
  }

  // Robust, double-safe submit for Quick View region clicks
  function submitEnclosingForm(btn) {
    const form =
      btn &&
      (btn.closest('form') ||
        btn.closest('product-form')?.querySelector('form'));
    if (!form || form.__bbSubmitting) return;
    form.__bbSubmitting = true;

    // Prefer native requestSubmit() to trigger the form’s submit listener (theme.js ProductForm)
    try {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        // Fallbacks: click the real button (to keep Recharge hooks), then dispatch a SubmitEvent
        btn.click();
        // If nothing picked it up, dispatch a synthetic submit that bubbles
        const ev = (typeof SubmitEvent === 'function')
          ? new SubmitEvent('submit', { bubbles: true, cancelable: true })
          : new Event('submit', { bubbles: true, cancelable: true });
        form.dispatchEvent(ev);
      }
    } finally {
      // guard reset shortly after to allow consecutive adds
      setTimeout(() => { form.__bbSubmitting = false; }, 600);
    }
  }

  function forwardIfNeeded(region, btn, evt) {
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    // If the click actually landed on the button (or within it), let native handlers run
    if (evt && evt.target && evt.target.closest(BUTTON_SELECTOR)) return;

    // Don’t hijack clicks on other obvious controls
    if (evt && isInteractiveTarget(evt.target)) return;

    const inQuickView = isQuickViewButton(btn);

    if (inQuickView) {
      // Quick View: be explicit — submit the form (belt-and-suspenders).
      // Do NOT stop propagation so Recharge can still see the event chain if it wants.
      submitEnclosingForm(btn);
    } else {
      // PDP/Featured: proxy click to the real button (type="button")
      btn.click();
    }
  }

  function bindRegion(region, btn) {
    if (!region || region.__bbRcBound) return;
    region.__bbRcBound = true;

    // Click anywhere on the region -> trigger appropriate action
    region.addEventListener(
      'click',
      function (e) {
        forwardIfNeeded(region, btn, e);
      },
      // capture=false so we don’t preempt theme/ReCharge listeners on the button itself
      false
    );

    // Keyboard support on wrapper (Enter/Space)
    region.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') forwardIfNeeded(region, btn, e);
    });
  }

  function wire(container) {
    toArray((container || document).querySelectorAll(BUTTON_SELECTOR)).forEach(function (btn) {
      normalizeButton(btn);
      const region = btn.closest(REGION_SELECTOR) || btn.parentElement;
      if (region) bindRegion(region, btn);
    });
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      wire(document);
    });
  } else {
    wire(document);
  }

  // Watch dynamically injected nodes (Quick View, featured re-renders, etc.)
  const mo = new MutationObserver(function (list) {
    for (const m of list) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          // If a button or a region appeared anywhere inside this node, (re)wire
          if (n.matches?.(BUTTON_SELECTOR) || n.querySelector?.(BUTTON_SELECTOR) ||
              n.matches?.(REGION_SELECTOR) || n.querySelector?.(REGION_SELECTOR)) {
            wire(n);
          }
        });
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Safety: if Recharge isn’t present (theme AJAX only), restore submit types
  setTimeout(function () {
    if (!isRechargePresent()) {
      toArray(document.querySelectorAll(BUTTON_SELECTOR)).forEach(restoreButton);
    }
  }, 1500);

  // Minimal debug helpers
  window.__BB_RC_ATC_DEBUG__ = {
    buttons: () => Array.from(document.querySelectorAll(BUTTON_SELECTOR)),
    regions: () => Array.from(document.querySelectorAll(REGION_SELECTOR)),
    rewire: () => wire(document)
  };
})();
